import CatalogMenuItem from "./CatalogMenuItem";
import {TopCategoryInterface} from "../../../interfaces/catalog/TopCategoryInterface";

export default function CatalogMenu({categories, closeMenu}: {categories: TopCategoryInterface[], closeMenu: () =>  void})
{
    return (<div className="header__mob-menu mob-menu your-menu menu-catalog" onClick={closeMenu}>
        <div className="container" >
            <div className="d-flex flex-column mob-menu__body" onClick={(e) => e.stopPropagation()}>
                <div className="icon-menu icon-menu-catalog mob-menu__close" onClick={closeMenu}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 17L1 1M17 1L1 17" stroke="#292929" strokeWidth="0.625"
                              stroke-linecap="round"/>
                    </svg>
                </div>

                <div className="d-flex align-items-center justify-content-center mob-menu__head _two">
                    <span className="fw-bold">Каталог</span>
                </div>
                <div className="mob-menu__search">
                    <div className="form-control-item">
                        <input type="text" className="form-control" name="_search-catalog"
                               placeholder="Всё для стройки, ремонта, производства"/>
                    </div>
                </div>
                <div className="d-flex flex-column mob-menu__list-row">
                    <ul className="d-flex flex-column mob-menu__list p-0">
                        {categories.map(categoryItem => <CatalogMenuItem topCategory={categoryItem} />)}
                    </ul>
                </div>

            </div>
        </div>

    </div>)
}